module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlmax/Nagano_Chlmax_MIROC5_RCP85_Mid.png";